module.exports = __webpack_public_path__ + "img/images_homebanner_3.360e39c7.png";